import { parsePhoneNumberFromString } from 'libphonenumber-js';

import type { TCode } from './countryUtils';

export function extractPhoneCode(phoneNumber: string) {
  const parsedNumber = parsePhoneNumberFromString(phoneNumber);

  return parsedNumber ? parsedNumber.countryCallingCode : null;
}

export function correctPhoneNumber(value: string): string {
  return value.replace(/[^\d\s]/g, '');
}

export function formatPhoneNumber(value = ''): string {
  const digits = correctPhoneNumber(value).replace(/\s+/g, '');
  if (digits.length <= 9) {
    return digits.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
  }

  return digits.replace(/(\d{4})(\d{3})(\d{3})(\d*)/, (_, a, b, c, rest) =>
    [a, b, c, rest].filter(Boolean).join(' '),
  );
}

interface ISanitizeDefaultPhoneNumberParams {
  code?: TCode;
  number?: string;
  country?: string;
}

export function sanitizeDefaultPhoneNumber({
  code,
  number,
  country,
}: ISanitizeDefaultPhoneNumberParams = {}): Required<ISanitizeDefaultPhoneNumberParams> {
  return {
    code: code || '+61',
    number: number || '',
    country: country || 'AU',
  };
}

export function hiddenPhoneNumber(phoneNumber: string) {
  const hidden = (phoneNumber ?? '').slice(0, -3);
  const showLastNumber = (phoneNumber ?? '').slice(-3);

  return `${hidden.replace(/\d/g, '*')}${showLastNumber}`;
}
